import React from "react";
import { Helmet } from "react-helmet";

import { SITE, getPageSeo } from "../../data/seo";

const asAbsoluteUrl = url => {
	if (!url) {
		return "";
	}

	if (/^https?:\/\//i.test(url)) {
		return url;
	}

	return `${SITE.siteUrl}${url.startsWith("/") ? url : `/${url}`}`;
};

const Seo = ({
	page,
	title,
	description,
	keywords,
	path,
	image,
	type = "website",
	noIndex = false,
}) => {
	const pageSeo = page ? getPageSeo(page) : null;

	const resolvedTitle = title || pageSeo?.title || SITE.defaultTitle;
	const resolvedDescription =
		description || pageSeo?.description || SITE.defaultDescription;
	const resolvedKeywords =
		keywords || pageSeo?.keywords || SITE.defaultKeywords;
	const resolvedPath = path || pageSeo?.path || "/";
	const resolvedImage = image || SITE.defaultImage;
	const resolvedNoIndex = noIndex || Boolean(pageSeo?.noIndex);
	const canonicalUrl = asAbsoluteUrl(resolvedPath);
	const imageUrl = asAbsoluteUrl(resolvedImage);
	const robotsValue = resolvedNoIndex
		? "noindex,nofollow,max-snippet:-1,max-image-preview:none"
		: "index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1";

	return (
		<Helmet>
			<title>{resolvedTitle}</title>
			<meta name="description" content={resolvedDescription} />
			<meta name="keywords" content={resolvedKeywords.join(", ")} />
			<meta name="robots" content={robotsValue} />
			<link rel="canonical" href={canonicalUrl} />

			<meta property="og:site_name" content={SITE.siteName} />
			<meta property="og:type" content={type} />
			<meta property="og:title" content={resolvedTitle} />
			<meta property="og:description" content={resolvedDescription} />
			<meta property="og:url" content={canonicalUrl} />
			<meta property="og:image" content={imageUrl} />

			<meta name="twitter:card" content="summary_large_image" />
			{SITE.twitterHandle && (
				<meta name="twitter:creator" content={SITE.twitterHandle} />
			)}
			<meta name="twitter:title" content={resolvedTitle} />
			<meta name="twitter:description" content={resolvedDescription} />
			<meta name="twitter:image" content={imageUrl} />
		</Helmet>
	);
};

export default Seo;
